import { OrmModel, StringField } from 'vuex-orm-decorators'
import { ApiResponse } from '@/dataAccess/dto/DTO'
import AbstractPerson from '@/dataAccess/models/AbstractPerson'

@OrmModel('limitedClients')
export default class LimitedClient extends AbstractPerson {
  @StringField()
  public birthDate: string

  /*
   * Configuration for Vuex ORM Plugin Axios
   */
  static apiConfig = {
    // eslint-disable-next-line
    dataTransformer({ data, headers }) {
      return data.map(o => LimitedClient.apiResponseMapper(o))
    }
  }

  /**
   * Map API response data structure to LimitedClient date structure
   */
  public static apiResponseMapper(data: ApiResponse): ApiResponse {
    return {
      id: data.id,
      fullName: data.full_name,
      birthDate: data.birth_date,
      isArchived: data.is_archived
    }
  }
}
